"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const focalTestimonials = [{
  quote: "آرتین فضایی را برای ما خلق کرد که با",
  highlight: "روح و سبک زندگی ما کاملاً همخوانی دارد",
  quoteEnd: "و هر روز از بودن در آن لذت می‌بریم.",
  name: "سارا راد",
  role: "کارفرمای مسکونی",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_sara.webp",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_sara.webp-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_sara.webp-wvc-sizes"
}, {
  quote: "دقت در جزئیات و ترکیب هوشمندانه رنگ‌ها در",
  highlight: "طراحی دفتر کار ما بی‌نظیر بود",
  quoteEnd: "و بازخورد فوق‌العاده‌ای از مراجعین دریافت کردیم.",
  name: "امیر نیک‌زاد",
  role: "مدیر فضای تجاری",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_amir.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_amir.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_amir.png-wvc-sizes"
}, {
  quote: "آرتین با نگاه مدرن خود توانست",
  highlight: "فضای کوچک ما را به محیطی دلباز و کاربردی",
  quoteEnd: "تبدیل کند که فراتر از انتظار ما بود.",
  name: "مریم کیانی",
  role: "طراح گرافیک",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_maryam.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_maryam.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_maryam.png-wvc-sizes"
}, {
  quote: "تجربه‌ای حرفه‌ای از مشاوره تا اجرا.",
  highlight: "خلاقیت آرتین در نورپردازی",
  quoteEnd: "فضای خانه ما را به یک اثر هنری تبدیل کرد.",
  name: "رضا همتی",
  role: "مشتری وفادار",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_reza.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_reza.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_reza.png-wvc-sizes"
}];
const smallTestimonials = [{
  quote: "یک همکاری لذت‌بخش با نتیجه‌ای که دقیقاً همان چیزی بود که در ذهن داشتم.",
  name: "نیلوفر پارسا",
  role: "معمار",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_niloufar.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_niloufar.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_niloufar.png-wvc-sizes"
}, {
  quote: "آرتین به خوبی می‌داند چگونه سلیقه شخصی را با استانداردهای مدرن ترکیب کند.",
  name: "سینا علوی",
  role: "کارآفرین",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_sina.webp",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_sina.webp-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_sina.webp-wvc-sizes"
}, {
  quote: "طراحی‌های آرتین نه تنها زیبا، بلکه بسیار کاربردی و آرامش‌بخش هستند.",
  name: "هدیه صبوری",
  role: "مدیر هنری",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_hedieh.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_hedieh.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/client_hedieh.png-wvc-sizes"
}];
export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const active = focalTestimonials[activeIndex];
  const handlePrev = () => {
    setActiveIndex(prev => prev === 0 ? focalTestimonials.length - 1 : prev - 1);
  };
  const handleNext = () => {
    setActiveIndex(prev => prev === focalTestimonials.length - 1 ? 0 : prev + 1);
  };
  const fullQuote = `${active.quote} ${active.highlight} ${active.quoteEnd}`;
  const words = fullQuote.split(" ");
  const highlightWords = active.highlight.split(" ");
  const highlightStart = active.quote.split(" ").length;
  const highlightEnd = highlightStart + highlightWords.length;
  return <section data-section-id="4213" id="روایت-مشتریان-ما" className="bg-background text-foreground py-24 md:py-32 lg:py-[140px] overflow-hidden">
      <div ref={sectionRef} className="container mx-auto px-6 md:px-10 lg:px-16">
        {}
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <span className="font-mono text-xs tracking-[0.2em] uppercase text-secondary">
              — 06 / روایت‌ها
            </span>
          </div>
        </div>

        {}
        <div className="grid grid-cols-12 gap-6 relative mb-24 md:mb-32 lg:mb-40">
          <div className="col-span-12 md:col-start-3 md:col-span-8 relative">
            {}
            <span aria-hidden="true" className="absolute -top-16 md:-top-20 lg:-top-24 -left-4 md:-left-12 lg:-left-16 font-serif text-[10rem] md:text-[14rem] lg:text-[18rem] leading-none text-primary select-none pointer-events-none">
              &ldquo;
            </span>

            {}
            <blockquote className="relative font-serif italic text-3xl md:text-5xl lg:text-[56px] leading-[1.15] text-foreground tracking-tight">
              {words.map((word, i) => {
              const isHighlight = i >= highlightStart && i < highlightEnd;
              return <span key={`${activeIndex}-${i}`} data-index={i} className="inline-block transition-all duration-700 ease-out" style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateY(0)" : "translateY(20px)",
                transitionDelay: `${i * 60}ms`,
                color: isHighlight ? "var(--primary)" : undefined
              }}>
                    {word}&nbsp;
                  </span>;
            })}
            </blockquote>

            {}
            <div className="mt-12 md:mt-16 flex items-center gap-5 transition-all duration-700 ease-out" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: `${words.length * 60 + 200}ms`
          }}>
              <SafeHydrate><Avatar className="size-16 border border-border">
                <AvatarImage src={active.avatar} alt={active.name} className="object-cover" />
                <AvatarFallback className="font-serif text-base">
                  {active.name.charAt(0)}
                </AvatarFallback>
              </Avatar></SafeHydrate>
              <div className="flex flex-col gap-1">
                <span className="font-serif text-lg text-foreground">
                  {active.name}
                </span>
                <span className="font-mono text-xs tracking-[0.18em] uppercase text-secondary">
                  — {active.role}
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="hidden md:flex absolute top-1/2 -translate-y-1/2 left-0 col-span-1">
            <Button variant="ghost" size="icon" onClick={handlePrev} aria-label="Previous testimonial" className="size-12 text-secondary hover:text-primary hover:bg-accent">
              <ChevronLeft className="size-6" strokeWidth={1.25} />
            </Button>
          </div>
          <div className="hidden md:flex absolute top-1/2 -translate-y-1/2 right-0 col-span-1 justify-end">
            <Button variant="ghost" size="icon" onClick={handleNext} aria-label="Next testimonial" className="size-12 text-secondary hover:text-primary hover:bg-accent">
              <ChevronRight className="size-6" strokeWidth={1.25} />
            </Button>
          </div>
        </div>

        {}
        <div className="flex justify-center gap-3 mb-20 md:mb-28">
          {focalTestimonials.map((_, i) => <Button key={i} data-index={i} variant="ghost" onClick={() => setActiveIndex(i)} aria-label={`Go to testimonial ${i + 1}`} className="p-2 h-auto w-auto">
              <span className="block size-2 transition-all duration-300" style={{
            backgroundColor: i === activeIndex ? "var(--primary)" : "var(--secondary)",
            opacity: i === activeIndex ? 1 : 0.3,
            width: i === activeIndex ? "1.5rem" : "0.5rem"
          }} />
            </Button>)}
        </div>

        {}
        <div className="flex md:hidden justify-center gap-4 mb-20">
          <Button variant="ghost" size="icon" onClick={handlePrev} aria-label="Previous testimonial" className="size-12 border border-border text-secondary hover:text-primary">
            <ChevronLeft className="size-5" strokeWidth={1.25} />
          </Button>
          <Button variant="ghost" size="icon" onClick={handleNext} aria-label="Next testimonial" className="size-12 border border-border text-secondary hover:text-primary">
            <ChevronRight className="size-5" strokeWidth={1.25} />
          </Button>
        </div>

        {}
        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {smallTestimonials.map((t, i) => {
          const colSpans = ["md:col-start-2 md:col-span-3", "md:col-start-5 md:col-span-4", "md:col-start-9 md:col-span-3"];
          return <div data-index={i} key={i} className={`col-span-12 ${colSpans[i]} border border-border bg-card p-7 md:p-8 transition-all duration-500 ease-out`} style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(24px)",
            transitionDelay: `${800 + i * 150}ms`
          }}>
                <SafeHydrate><Avatar className="size-14 mb-5 border border-border">
                  <AvatarImage src={t.avatar} alt={t.name} className="object-cover" />
                  <AvatarFallback className="font-serif">
                    {t.name.charAt(0)}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                <p className="font-serif italic text-base md:text-lg leading-snug text-foreground mb-6">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="flex flex-col gap-1 pt-5 border-t border-border">
                  <span className="font-serif text-sm text-foreground">
                    {t.name}
                  </span>
                  <span className="font-mono text-[10px] tracking-[0.18em] uppercase text-secondary">
                    — {t.role}
                  </span>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}